import { Component, Input, OnChanges } from '@angular/core';
import icons from '../../../../assets/icons/icons.json';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgIf } from '@angular/common';

interface Icon {
  icon: string;
  viewBox: string;
}

@Component({
    selector: 'fk-icon',
    templateUrl: './icon.component.html',
    styles: [`
    :host {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    svg {
        fill: currentColor;
    }
  `],
    imports: [NgIf],
})
export class IconComponent implements OnChanges {
  /**
   * Icon size
   */
  @Input()
  public size = 24;

  @Input()
  public name = '';

  protected iconContent!: SafeHtml;
  protected viewBox!: string;

  constructor(private domSanitizer: DomSanitizer) {}

  public ngOnChanges() {
    this.iconContent = this.domSanitizer.bypassSecurityTrustHtml((<{ [key: string]: Icon }>icons)[this.name].icon);
    this.viewBox = (<{ [key: string]: Icon }>icons)[this.name].viewBox;
  }
}
